<template>
    <el-dialog title="选择书籍" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
            <el-form-item label="书籍名称" prop="bookName">
                <el-input v-model="formInline.bookName" placeholder="请输入书籍名称" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item label="书籍ID" prop="bookId">
                <el-input type="number" v-model="formInline.bookId" placeholder="请输入书籍ID" clearable @keyup.enter.native="search" @clear="search" style="width: 220px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tableTh">
            <el-table :data="tableData.result" ref="singleTable" border highlight-current-row
                      @current-change="handleCurrentChangeTable" height="345" row-key="id" style="width: 100%" class="tableStyle table-radio">
                <el-table-column align="center" width="55" label>
                    <template slot-scope="scope">
                        <el-checkbox @change.native="handleCurrentChangeTable(scope.row)" v-model="selected" :label="scope.row.bookId"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="封面" width="100">
                    <template slot-scope="scope">
                        <img class="cover-td" :src="scope.row.coverName" height="50"/>
                    </template>
                </el-table-column>
                <el-table-column label="书名" width="160">
                    <template slot-scope="scope">
                        <span>{{scope.row.bookName}}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column label="别名" width="160">-->
                    <!--<template slot-scope="scope">-->
                        <!--<span>{{scope.row.aliasName}}</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column prop="id" label="书籍信息">
                    <template slot-scope="scope">
                        <div class="td-info">
                            <p>推荐语: {{scope.row.recText}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="statusOnline" label="状态" width="80">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rackStatus == 0" class="danger-text">已下架</span>
                        <span v-if="scope.row.rackStatus == 1" class="succes-text">上架中</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :page-sizes="[5, 20, 50, 100, 200, 500]"
                        :page-size="pageSize"
                        background
                        :current-page="currentPage"
                        layout="sizes, prev, pager, next, jumper, ->, total"
                        :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { listBook, listBookDy } from "@/api/wb/booklist/book";
export default {
    name: 'BookTable',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        selectBook: {
            type: Object,
            required: true
        },
        appId: String
    },
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInline: {
                bookId: '',
                bookName: ''
            },
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: []
            },
            currentPage: 1,
            pageSize: 5,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            console.log(this.selectBook)
            // 弹框显示赋值默认值
            this.$nextTick(()=>{
                this.$refs.singleTable.setCurrentRow(this.selectBook)
            })
        },
        appId(newValue) {
            console.log('图书列表', newValue)
            this.appId = newValue
            this.getTableBook()
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        }
    },
    mounted() {
        this.getTableBook()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableBook()
        },
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableBook()
        },
        // 分页
        handleCurrentChange (value) {
            this.currentPage = value
            this.getTableBook()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableBook()
        },
        // 单选
        handleCurrentChangeTable(val) {
            console.log('单选')
            this.$refs.singleTable.setCurrentRow(val);
            this.currentRow = val
            // this.selected = val.id
            console.log(val)
            this.selected = [val.bookId]
        },
        // 确定按钮
        tableSureBtn() {
            this.$emit('bookSure', this.currentRow);
            this.$emit('cancelDialogBook', false);
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log(22)
            this.$emit('cancelDialogBook', false);
        },
        getTableBook() {
            if (localStorage.getItem('platform') == 'wb-dp') {
                let json2 = {
                    appId: this.appId,
                    pageNo: this.currentPage,
                    pageSize: this.pageSize
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                listBook(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            } else {
                let json2 = {
                    appId: this.appId,
                    pageNo: this.currentPage,
                    pageSize: this.pageSize,
                    rackStatus: 1,
                };
                let json1 = this.formInline;
                let paramJson = { ...json1, ...json2 };
                listBookDy(paramJson).then(response => {
                    if (response.data.head.flag === 0) {
                        this.tableData = response.data.content
                    } else {
                        this.$message.error(response.data.head.desc)
                    }
                });
            }
        },
    }
}
</script>
